import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import {
  ICardPhoneBindingChangeHistoryItem,
  ICardPhoneBindingFilter,
  ICardPhoneBindingListResult,
  ICardPhoneVerificationHistoryItem,
} from '../models/models'

export class CardPhoneBindingApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: '',
      requesterInfo,
    })
  }

  public async getAll(filter: ICardPhoneBindingFilter): Promise<ICardPhoneBindingListResult> {
    this.props.url = 'admin/cardPhoneBinding/getAll'
    return await this.postAsync<ICardPhoneBindingListResult>(filter)
  }

  public async update(id: number, phone: string): Promise<boolean> {
    this.props.url = 'admin/cardPhoneBinding/update'
    return await this.postAsync<boolean>({ Id: id, Phone: phone })
  }

  public async remove(id: number): Promise<boolean> {
    this.props.url = `admin/cardPhoneBinding/delete/${id}`
    return await this.deleteAsync<boolean>()
  }

  public async history(bindingId: number): Promise<ICardPhoneVerificationHistoryItem[]> {
    this.props.url = 'admin/cardPhoneBinding/history'
    return await this.postAsync<ICardPhoneVerificationHistoryItem[]>(bindingId)
  }

  public async changeHistory(bindingId: number): Promise<ICardPhoneBindingChangeHistoryItem[]> {
    this.props.url = 'admin/cardPhoneBinding/changeHistory'
    return await this.postAsync<ICardPhoneBindingChangeHistoryItem[]>(bindingId)
  }
}
